import { objectTypes, actionNames, actionPrefixes } from "@newsela/snitch";

import { AgathaSchemaParamsEnum } from "../../types/IParametersSchema";

export const NO_CLEAR_FILTERS: string[] = [
  AgathaSchemaParamsEnum.sort_by,
  AgathaSchemaParamsEnum.language,
];

export const NO_SHOW_FILTERS: string[] = [
  AgathaSchemaParamsEnum.page,
  AgathaSchemaParamsEnum.needle,
  AgathaSchemaParamsEnum.sort_by,
  AgathaSchemaParamsEnum.language,
  AgathaSchemaParamsEnum.content_id,
  AgathaSchemaParamsEnum.content_types,
  AgathaSchemaParamsEnum.admin_content_settings,
];

export const NO_SHOW_K2_READ_ALOUD_FILTERS: string[] = [
  AgathaSchemaParamsEnum.grade_level,
];

type eventPropertiesType = "clear" | "collapse" | "show";

const EventPropertiesDescription: Record<eventPropertiesType, string> = {
  clear: "Clear search filters on the new search mvp",
  collapse: "Collapse all search filters chips on the new search mvp",
  show: "Show all search filters chips on the new search mvp",
};

export const eventProperties = (type: eventPropertiesType) => ({
  objectType: objectTypes.content,
  actionPrefix: actionPrefixes.initiate,
  actionName: actionNames.filter,
  streamProperties: {
    description: EventPropertiesDescription[type],
  },
});

export const MAX_FILTERS_DISPLAY_COLLAPSED = 4;
